import { Box, FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 32
const ITEM_PADDING_TOP = 8

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .label-text {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
`

export const IntegrationsFormControl = styled(FormControl)<{ isselected?: string; isopen?: string }>`
  background: transparent;
  outline: none;
  border: 0;
  display: flex;
  color: ${theme.colors.foreground};
  text-align: center;
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;

  ${({ isopen }) =>
    isopen === 'true' &&
    `
        color: ${theme.colors.cta};
    `};

  .is-open {
    path {
      stroke: ${theme.colors.cta};
    }
  }

  .MuiOutlinedInput-root {
    background: transparent;
    border: 0;
    outline: 0;
    text-align: center;
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${({ isopen }) => (isopen && isopen === 'true' ? theme.colors.cta : theme.colors.menuItemText)};
    gap: ${theme.spacing.xSmall}px;

    > * {
      border: none !important;
      outline: none !important;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }

    .MuiSelect-select {
      padding: 0 42px 0 0;
    }
  }

  &:hover {
    border-color: #6c5b67;

    html[data-theme='light'] & {
      border-color: ${theme.colors.dropdownBorder};
    }

    svg {
      path {
        stroke: ${theme.colors.cta};
      }
    }

    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }
  }

  svg {
    top: calc(50% - 0.6em);
    right: ${theme.spacing.small}px;
  }

  fieldset {
    padding: 0;
  }
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      background: '#372E35',
      "html[data-theme='light'] &": {
        background: theme.colors.surfaceContainerBackground
      },
      borderRadius: '12px',
      boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.20)',
      width: '244px',
      minHeight: 'unset !important',
      maxHeight: 'unset !important',
      marginTop: '8px',
      padding: '6px 0',

      '.MuiList-root': {
        padding: 0
      },

      '.MuiMenuItem-root': {
        height: '42px',
        paddingLeft: `${theme.spacing.small}px`,
        paddingRight: `${theme.spacing.medium}px`,

        '&:hover': {
          background: `${theme.colors.menuItemHover} !important`
        },

        '.MuiCheckbox-root': {
          paddingRight: '8px',
          paddingLeft: 0,

          '&:not(.Mui-checked) svg path': {
            stroke: theme.colors.devicesSecondaryText
          },

          '&.Mui-checked': {
            color: theme.colors.checkboxChecked
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          color: theme.colors.devicesSecondaryText,
          fontFamily: 'Quicksand, sans-serif',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '22px'
        },

        display: 'flex',
        alignItems: 'center',
        width: '100%'
      },

      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  marginThreshold: 36, // add 36px to the right to align with the padding in the select input
  variant: 'menu' as const,
  getContentAnchorEl: null
}
